export enum ErrorCodes {
	DUPLICATE_RECORD = 'DUPLICATE_RECORD',
	MAX_AMOUNT_EXCEEDED = 'MAX_AMOUNT_EXCEEDED',
	NOTIFICATION_FAILURE = 'NOTIFICATION_FAILURE',
}
